/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:26:23
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-08-08 20:15:54
 * @FilePath: /vue_huaqiang/src/router/modules/purchase-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const purchaseManagementRoutes: RouteConfig[] = [
  {
    path: "/purchaseOrderManagement",
    component: Layout,
    redirect: "/supplierOrderManagement",
    name: "purchaseOrderManagement",
    meta: {
      title: "purchaseOrderManagement",
      icon: "el-icon-s-goods",
      alwaysShow: true
    },
    children: [
      {
        path: "/supplierOrderManagement",
        name: "supplierOrderManagement",
        meta: { title: "supplierOrderManagement" },
        component: () =>
          import("@/views-oms/purchase-order-management/supplier/index.vue")
      },
      {
        path: "/viewAllPurchaseOrders",
        name: "viewAllPurchaseOrders",
        meta: { title: "viewAllPurchaseOrders" },
        component: () =>
          import("@/views-oms/purchase-order-management/order/all/index.vue")
      },
      {
        path: "/poDeliveryTracking",
        name: "poDeliveryTracking",
        meta: { title: "poDeliveryTracking" },
        component: () =>
            import("@/views-oms/purchase-order-management/delivery-tracking/index.vue")
      },
      {
        path: "/viewAllClaims",
        name: "viewAllClaims",
        meta: { title: "viewAllClaims" },
        component: () =>
          import("@/views-oms/purchase-order-management/claims/index.vue")
      },
      {
        path: "/purchaseOrderDetails",
        name: "purchaseOrderDetails",
        meta: { title: "purchaseOrderDetails", hidden: true, activeMenu: "/supplierOrderManagement" },
        component: () =>
          import("@/views-oms/purchase-order-management/order/details.vue")
      },
      {
        path: "/managePurchaseOrders",
        name: "managePurchaseOrders",
        meta: { title: "managePurchaseOrders", hidden: true, activeMenu: "/supplierOrderManagement" },
        component: () =>
          import("@/views-oms/purchase-order-management/order/index.vue")
      },
      {
        path: "/paymentTermsMaintenance",
        name: "paymentTermsMaintenance",
        meta: { title: "paymentTermsMaintenance", hidden: true, activeMenu: "/supplierOrderManagement" },
        component: () =>
          import("@/views-oms/purchase-order-management/payment/index.vue")
      },
      {
        path: "/creditNoteManagement",
        name: "creditNoteManagement",
        meta: { title: "creditNoteManagement",},
        component: () =>
          import("@/views-oms/credit-note-management/credit-note/index.vue")
      },
      {
        path: "/claimManagement",
        name: "claimManagement",
        meta: { title: "claimManagement",hidden: true, activeMenu: "/creditNoteManagement"},
        component: () =>
          import("@/views-oms/credit-note-management/claim-management/index.vue")
      },
      {
        path: "/claimDetails",
        name: "claimDetails",
        meta: { title: "claimDetails",hidden: true, activeMenu: "/claimDetails"},
        component: () =>
          import("@/views-oms/credit-note-management/claim-management/details.vue")
      }

    ]
  }
];

export default purchaseManagementRoutes;
